import React, { useEffect, useState } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import search from "../../../assets/icons/searchIcon.svg";
import Select from "react-select";
import { discustomStyles } from "../../../components/discounts/discount-group/item-group-tab";
import { useDispatch } from "react-redux";
import { priceListAction } from "../../../redux/actions/general-action";
import AddButton from "../../../components/buttons/button";
import {
  perDisItemsListAction,
  perVolCreateAction,
} from "../../../redux/actions/discount-action";
import KibabMenu from "../../../assets/icons/kibab-menu";
import EditIcon, { VoidIcon } from "../../../assets/icons/action-icons";
import PeriodVolumeModal from "../../../components/modals/discounts-modals/period-volume-modal";
import errorToast from "../../../components/helper-components/error-toast";
import successToast from "../../../components/helper-components/success-toast";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import moment from "moment";
import PeriodVolumePopover from "../../../components/discounts/period-volume-discount/period-volume-popover";
import { useHotkeys } from "react-hotkeys-hook";
import { ChevronLeftIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";

const PeriodVolumeDiscounts = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [checkedId, setCheckedId] = useState([]);
  const [showPerVolumePopover, setShowPerVolumePopover] = useState(false);
  const [periodDiscountItemId, setPeriodDiscountItemId] = useState(null);

  const [showLeaveConfirm, setShowLeaveConfirm] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);

  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // ✅ Action menu state: use a UNIQUE row key so it never opens twice
  const [actionOpen, setActionOpen] = useState(false);
  const [currentMenuKey, setCurrentMenuKey] = useState(null);

  const [inputValue, setInputValue] = useState("");
  const [priceList, setPriceList] = useState([]);
  const [initialData, setInitialData] = useState({});

  useEffect(() => {
    dispatch(priceListAction(onpriceSuccess, onpriceError));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onpriceSuccess = (data) => {
    setPriceList(
      (data?.data || []).map((item) => ({
        label: item?.price_list_name,
        value: item?.price_list_id,
      }))
    );
  };

  const onpriceError = () => {};

  const initialValues = {
    price_list_id: initialData?.price_list_id || "",
    price_list_name: initialData?.price_list_name || "",
    from_date: initialData?.from_date
      ? moment(initialData?.from_date).format("YYYY-MM-DD")
      : "",
    to_date: initialData?.to_date
      ? moment(initialData?.to_date).format("YYYY-MM-DD")
      : "",
    ItemsData:
      initialData?.items?.length > 0
        ? initialData?.items?.map((item) => ({
            item_id: item?.item_id,
            period_discount_item_id: item?.period_discount_item_id,
            item_code: item?.item_code ?? "",
            item_name: item?.item_name ?? "",
            item_batch_number: item?.item_batch_number ?? "",
            base_price_list: item?.base_price_list ?? "",
            item_base_price: item?.item_base_price ?? "",
            item_selling_price: item?.item_selling_price ?? "",
            discount_percentage: item?.discount_percentage ?? "",
            default_factor: item?.default_factor ?? "",
            item_pricing_uom: item?.item_pricing_uom ?? null,
          }))
        : [],
  };

  const validationSchema = Yup.object().shape({});

  const confirmNavigation = (call = null) => {
    setPendingAction(() => call);
    setShowLeaveConfirm(true);
  };

  const onConfirmLeave = () => {
    const fn = pendingAction;
    setShowLeaveConfirm(false);
    setPendingAction(null);

    if (typeof fn === "function") fn();
    else navigate(-1);
  };

  const onCancelLeave = () => {
    setShowLeaveConfirm(false);
    setPendingAction(null);
  };

  function perDisItemsListFn(price_list_id) {
    setLoading(true);
    dispatch(
      perDisItemsListAction(
        { price_list_id },
        onSuccess,
        () => {
          setInitialData({ price_list_id });
          setLoading(false);
        }
      )
    );
  }

  const onSuccess = (data) => {
    setInitialData(data?.data?.[0] || {});
    setLoading(false);
  };

  // Close action dropdown on outside click
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (!actionOpen) return;
      if (!event?.target?.closest?.(".pv-action-wrap")) {
        setActionOpen(false);
        setCurrentMenuKey(null);
      }
    };
    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, [actionOpen]);

  const onSubmit = (values) => {
    dispatch(
      perVolCreateAction(
        {
          priceListData: {
            price_list_id: values?.price_list_id,
            from_date: values?.from_date,
            to_date: values?.to_date,
          },
          ItemsData: (values?.ItemsData || []).map((item) => ({
            item_id: item?.item_id,
            item_batch_number: item?.item_batch_number,
          })),
        },
        (data) => {
          perDisItemsListFn(values?.price_list_id);
          successToast(data?.message);
        },
        () => errorToast("Please select from and to date")
      )
    );
  };

  useHotkeys("escape", () => {
    setShowPerVolumePopover(false);
    setIsModalOpen(false);
    setActionOpen(false);
    setCurrentMenuKey(null);
  });

  function checkboxChecker(e, all) {
    if (all === "all") {
      const ids = (e || []).map((id) => String(id));
      if (checkedId.length === ids.length) setCheckedId([]);
      else setCheckedId(ids);
      return;
    }

    const id = String(e?.target?.id || "");
    if (!id) return;

    if (checkedId.includes(id)) {
      setCheckedId((prev) => prev.filter((x) => x !== id));
    } else {
      setCheckedId((prev) => [...prev, id]);
    }
  }

  // ✅ Unique per-row key (prevents menu rendering twice when period_discount_item_id duplicates)
  const getMenuKey = (rowData, idx) =>
    `${rowData?.item_id ?? "na"}|${rowData?.item_batch_number ?? "na"}|${
      rowData?.period_discount_item_id ?? "na"
    }|${idx}`;

  const toggleMenu = (menuKey) => {
    if (actionOpen && currentMenuKey === menuKey) {
      setActionOpen(false);
      setCurrentMenuKey(null);
    } else {
      setActionOpen(true);
      setCurrentMenuKey(menuKey);
    }
  };

  return (
    <>
      <InnerLayout title="Settings">
        <Formik
          key={loading ? "loading" : "ready"}
          enableReinitialize={true}
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({ handleSubmit, values, setFieldValue, dirty }) => {
            const filteredItems =
              values?.ItemsData?.filter((item) =>
                (item?.item_name || "")
                  .toLowerCase()
                  .includes((inputValue || "").toLowerCase())
              ) || [];

            const allIds = (values?.ItemsData || []).map((it) =>
              String(it?.item_id)
            );

            const isAllChecked =
              checkedId.length > 0 && checkedId.length === allIds.length;

            return (
              <>
                <PeriodVolumeModal
                  itemData={values}
                  setFieldValue={setFieldValue}
                  setIsModalOpen={setIsModalOpen}
                  isModalOpen={isModalOpen}
                />

                {showPerVolumePopover === true && (
                  <PeriodVolumePopover
                    periodDiscountItemId={periodDiscountItemId}
                    item={
                      values?.ItemsData?.find(
                        (item) =>
                          item?.period_discount_item_id === periodDiscountItemId
                      ) || null
                    }
                    setShowPerVolumePopover={setShowPerVolumePopover}
                    confirmNavigation={() =>
                      confirmNavigation(() => setShowPerVolumePopover(false))
                    }
                  />
                )}

                <div className="mx-6 py-3 flex items-center gap-2 text-sml">
                  <button
                    type="button"
                    className="flex items-center gap-2"
                    onClick={() => {
                      if (dirty) confirmNavigation(() => navigate("/settings"));
                      else navigate("/settings");
                    }}
                  >
                    <ChevronLeftIcon className="h-5 w-5 inline-block" />
                    Discount Settings /
                  </button>
                  <span className="cursor-pointer">
                    {" " + "Period and volume discounts"}
                  </span>
                </div>

                <Form className="h-full flex flex-col mt-2 mx-6">
                  <div className="grow">
                    <div className="flex gap-1 my-3 flex-wrap justify-between">
                      <div
                        style={{ width: "22rem", height: "2.5rem" }}
                        className={`input_border flex items-center rounded-md pb-1`}
                      >
                        <span className="px-2">
                          <img width={"16px"} src={search} alt="search icon" />
                        </span>
                        <input
                          placeholder={`Search here`}
                          className="table_search_input w-full rounded-md fs_12 placeholder:text-fs_12"
                          type="text"
                          value={inputValue}
                          onChange={(e) => setInputValue(e?.target?.value)}
                        />
                      </div>

                      <div className="flex gap-4">
                        <div
                          style={{ width: "fit-content" }}
                          className="border-D0D5DD border-2 h-[2.75rem] rounded-md text-344054 fw_600 flex items-center md:flex-wrap text-sm"
                        >
                          <button
                            type="button"
                            onClick={() => {
                              if (values?.price_list_id) setIsModalOpen(true);
                              else errorToast("Please select price list");
                            }}
                            className="px-2"
                          >
                            Add Items
                          </button>

                          <div className="h-[2.6rem] w-0.5 border-r-D0D5DD border-r-2 mx-2"></div>

                          <Field name="price_list_id">
                            {({ field }) => (
                              <Select
                                {...field}
                                styles={discustomStyles}
                                options={priceList}
                                value={
                                  priceList.find(
                                    (option) =>
                                      option.value === values.price_list_id
                                  ) || ""
                                }
                                onChange={(selectedOption) => {
                                  setFieldValue(
                                    "price_list_id",
                                    selectedOption.value
                                  );
                                  perDisItemsListFn(selectedOption?.value);
                                  setFieldValue(
                                    "price_list_name",
                                    selectedOption.label
                                  );
                                }}
                                placeholder="Select Price list"
                                isSearchable={false}
                              />
                            )}
                          </Field>

                          <div className="h-[2.6rem] w-0.5 border-r-D0D5DD border-r-2 mx-2"></div>
                          <span className="mr-2 text-sm">From :{"  "}</span>
                          <Field name={`from_date`}>
                            {({ field }) => (
                              <input
                                placeholder="  "
                                {...field}
                                type="date"
                                className={`text-sm text-value-color placeholder:text-placeholder-color w-[7rem] focus_outline__none input-field-no-spin-buttons`}
                              />
                            )}
                          </Field>

                          <div className="h-[2.6rem] w-0.5 border-r-D0D5DD border-r-2 mx-2"></div>
                          <span className="mr-2 text-sm">to :{"  "}</span>
                          <Field name={`to_date`}>
                            {({ field }) => (
                              <input
                                placeholder="  "
                                {...field}
                                type="date"
                                className={`text-sm text-value-color placeholder:text-placeholder-color w-[7rem] focus_outline__none input-field-no-spin-buttons`}
                              />
                            )}
                          </Field>
                        </div>
                      </div>
                    </div>

                    {loading ? (
                      <LoadingSpinner />
                    ) : (
                      <div className="overflow-auto mb-auto rounded-xl table-container border border-gray-200">
                        <table className="w-full">
                          <thead className="sticky top-0 bg-[var(--create-table-header-bg)] z-[10]">
                            <tr className="relative h-[50px]">
                              <th className="text-start px-[8px] whitespace-nowrap text-[var(--create-table-header-fg)] text-[length:var(--create-table-header-fs)] font-[var(--create-table-header-fw)]">
                                <input
                                  checked={isAllChecked}
                                  onChange={() => checkboxChecker(allIds, "all")}
                                  style={{ transform: "scale(1.1)" }}
                                  type="checkbox"
                                  id="myCheckbox"
                                  className="custom-checkbox form-check-input cursor-pointer"
                                />
                              </th>

                              {tableHeading.map((heading, index) => (
                                <th
                                  key={index}
                                  className={`${"price-tab-header"} ${
                                    heading?.label === "Action" &&
                                    "flex justify-end pe-10"
                                  } px-[8px] whitespace-nowrap text-[var(--create-table-header-fg)] text-[length:var(--create-table-header-fs)] font-[var(--create-table-header-fw)]`}
                                >
                                  {heading?.label}
                                </th>
                              ))}
                            </tr>
                          </thead>

                          <tbody className="h-full">
                            {filteredItems.length > 0 ? (
                              <>
                                {filteredItems.map((rowData, idx) => {
                                  const rowItemIdStr = String(rowData?.item_id);
                                  const rowActionId =
                                    rowData?.period_discount_item_id;

                                  const menuKey = getMenuKey(rowData, idx);

                                  return (
                                    <tr
                                      className={`${
                                        checkedId.includes(rowItemIdStr) &&
                                        "bg-D5E6Ff hover:bg-D5E6Ff"
                                      } hover:bg-f3f8ff`}
                                      key={menuKey}
                                    >
                                      <td className="text-sm tab-cell fw_400 text-secondary">
                                        <input
                                          checked={checkedId.includes(
                                            rowItemIdStr
                                          )}
                                          id={rowItemIdStr}
                                          onChange={(e) => checkboxChecker(e)}
                                          style={{ transform: "scale(1.2)" }}
                                          type="checkbox"
                                          className="custom-checkbox form-check-input cursor-pointer"
                                        />
                                      </td>

                                      <td className="price-tab-cell text-sm fw_400 text-secondary whitespace-nowrap">
                                        {rowData?.item_code}
                                      </td>
                                      <td className="price-tab-cell text-sm fw_400 text-secondary whitespace-nowrap">
                                        {rowData?.item_name ?? "--"}
                                      </td>
                                      <td className="price-tab-cell text-sm fw_400 text-secondary whitespace-nowrap">
                                        {rowData?.item_batch_number ?? "--"}
                                      </td>
                                      <td className="price-tab-cell text-sm fw_400 text-secondary whitespace-nowrap">
                                        {rowData?.base_price_list ?? "--"}
                                      </td>
                                      <td className="price-tab-cell text-sm fw_400 text-secondary whitespace-nowrap">
                                        {rowData?.item_base_price ?? "--"}
                                      </td>
                                      <td className="price-tab-cell text-sm fw_400 text-secondary whitespace-nowrap">
                                        {rowData?.item_selling_price ?? "--"}
                                      </td>
                                      <td className="price-tab-cell text-sm fw_400 text-secondary whitespace-nowrap">
                                        {rowData?.discount_percentage ?? "--"}
                                      </td>
                                      <td className="price-tab-cell text-sm fw_400 text-secondary whitespace-nowrap">
                                        {rowData?.default_factor ?? "--"}
                                      </td>
                                      <td className="price-tab-cell text-sm fw_400 text-secondary whitespace-nowrap">
                                        {rowData?.item_pricing_uom == null
                                          ? "--"
                                          : rowData?.item_pricing_uom}
                                      </td>

                                      <td className="price-tab-cell text-sm fw_400 text-secondary whitespace-nowrap">
                                        <div className="relative pv-action-wrap">
                                          {rowActionId && (
                                            <button
                                              type="button"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                toggleMenu(menuKey);
                                              }}
                                            >
                                              <KibabMenu />
                                            </button>
                                          )}

                                          {actionOpen &&
                                          currentMenuKey === menuKey ? (
                                            <div
                                              style={{
                                                minWidth: "13rem",
                                                zIndex: 999,
                                                top: "0px",
                                                right: "-20px",
                                              }}
                                              className="absolute border border-EAECF0 border-solid border-1 top-4 right-0 mt-8 py-4 px-4 bg-white rounded shadow-lg z-10 flex flex-col gap-3"
                                              onClick={(e) => e.stopPropagation()}
                                            >
                                              <button
                                                type="button"
                                                onClick={() => {
                                                  setPeriodDiscountItemId(
                                                    rowActionId
                                                  );
                                                  setActionOpen(false);
                                                  setCurrentMenuKey(null);
                                                  setShowPerVolumePopover(true);
                                                }}
                                                className="flex items-center gap-2 fw_500 text-sm"
                                              >
                                                <EditIcon />
                                                Period and Volume
                                              </button>

                                              <button
                                                type="button"
                                                onClick={() => {
                                                  // ✅ delete EXACT one matching row (handles duplicates safely)
                                                  const idxToRemove = (
                                                    values?.ItemsData || []
                                                  ).findIndex((x) => {
                                                    return (
                                                      String(x?.item_id) ===
                                                        String(
                                                          rowData?.item_id
                                                        ) &&
                                                      String(
                                                        x?.item_batch_number ??
                                                          ""
                                                      ) ===
                                                        String(
                                                          rowData?.item_batch_number ??
                                                            ""
                                                        ) &&
                                                      String(
                                                        x?.period_discount_item_id ??
                                                          ""
                                                      ) ===
                                                        String(
                                                          rowData?.period_discount_item_id ??
                                                            ""
                                                        )
                                                    );
                                                  });

                                                  if (idxToRemove >= 0) {
                                                    const next = [
                                                      ...(values?.ItemsData ||
                                                        []),
                                                    ];
                                                    next.splice(idxToRemove, 1);
                                                    setFieldValue(
                                                      "ItemsData",
                                                      next
                                                    );
                                                  }

                                                  setCheckedId((prev) =>
                                                    prev.filter(
                                                      (x) =>
                                                        x !==
                                                        String(rowData?.item_id)
                                                    )
                                                  );

                                                  setActionOpen(false);
                                                  setCurrentMenuKey(null);
                                                }}
                                                className="flex items-center gap-2 fw_500 text-sm"
                                              >
                                                <VoidIcon />
                                                Delete
                                              </button>
                                            </div>
                                          ) : null}
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })}

                                <tr style={{ height: "10rem" }}></tr>
                              </>
                            ) : (
                              <tr style={{ height: "20rem" }}>
                                <td
                                  colSpan={tableHeading.length + 1}
                                  className="text-center text-primary"
                                >
                                  No Items found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>

                  <div
                    style={{ bottom: "0" }}
                    className="flex items-start justify-end mb-5x sticky bg-white py-4"
                  >
                    <AddButton
                      onclkFn={handleSubmit}
                      prefixIcon={false}
                      text="Save"
                      type="submit"
                      className="
                        flex items-center px-3 py-2 whitespace-nowrap rounded-md gap-[8px]
                        bg-[var(--primary-button-bg-color)] cursor-pointer
                        text-[var(--primary-button-fg-color)]
                        border border-[var(--primary-button-bg-color)]
                        hover:bg-[var(--primary-button-hover-color)]
                        text-[length:var(--primary-button-create-fs)] 
                        font-[var(--primary-button-font-weight)]
                      "
                    />
                  </div>
                </Form>

                {showLeaveConfirm && (
                  <div className="fixed inset-0 z-[9999] grid place-items-center">
                    <div className="absolute inset-0 bg-black opacity-30" />
                    <div className="relative w-[90%] max-w-md rounded-2xl bg-white p-6 shadow-xl">
                      <h3 className="text-lg font-semibold text-gray-800">
                        Leave without saving?
                      </h3>
                      <p className="mt-2 text-sm text-gray-600">
                        All your changes will not be saved.
                      </p>

                      <div className="mt-6 flex justify-end gap-3">
                        <button
                          type="button"
                          className="px-4 py-2 rounded-lg border border-[var(--remove-color)] bg-[var(--remove-color)] text-white hover:opacity-90"
                          onClick={onCancelLeave}
                        >
                          No
                        </button>
                        <button
                          type="button"
                          className="px-4 py-2 rounded-lg bg-[var(--primary)] text-white hover:opacity-90"
                          onClick={onConfirmLeave}
                        >
                          Yes
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </>
            );
          }}
        </Formik>
      </InnerLayout>
    </>
  );
};

export default PeriodVolumeDiscounts;

const tableHeading = [
  { label: "ITEM CODE" },
  { label: "PRODUCT NAME" },
  { label: "Batch Number" },
  { label: "BASE PRICE LIST" },
  { label: "BASE PRICE" },
  { label: "SELLING PRICE" },
  { label: "DISCOUNT %" },
  { label: "% RELATED TO BASE PRICE" },
  { label: "UNIT" },
  { label: "" },
];
